import { guardedCustomElement } from '../utils/guarded-custom-element';
import { SDSHeadingComponent } from './sds-heading.component';

@guardedCustomElement('sds-heading')
export class SDSHeading extends SDSHeadingComponent {}

declare global {
	interface HTMLElementTagNameMap {
		'sds-heading': SDSHeading;
	}
}
